/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <public-title>关联企业 

    </public-title>
    <div class="load-area"  v-loading="loading">
      <el-tabs v-model="activeTab" class="mb-4" @tab-click="currentPage=1;getLists()" v-show="isAdmin">
        <el-tab-pane :label="item.name" :name="item.id" :key="item.name" v-for="item in $GVAR.StoreTypeStr"/>
      </el-tabs>
      <p v-if="salesAssociationLists.total<=0">当前没有数据</p>
      <div v-else>
        <ul class="list-head">
          <template v-for="item in titleArr">
            <li :class="item.width"  :key="item.name" v-if="activeName!=item.show">
              {{item.name}}
            </li>
          </template>
        </ul>
        <ul class="list-item"  v-for="Itemize in salesAssociationLists.lists" :key="Itemize.id">
          <li class="w-80 list-item-col">{{Itemize.title}}</li>
          <li class="w-20 list-item-col text-success">关联中</li>
          <li  class="w-20 list-item-col-end">
              <el-button type="danger" @click="deleteItem(Itemize)" size="mini">解除关联</el-button>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="salesAssociationLists.total" :current-page="Number(queryCon.page)"
                       @current-change="v => this.currentPage=v"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState } from 'vuex'

  export default {
    name: 'Lists',
    computed: {
      ...mapState(['salesAssociationLists','positionDetail','userLoginMessage']),
      ...mapGetters(['storeInfo','isGroup','userInfo','isAdmin']),
      powerArr() { return this.positionDetail.power_arr },
      queryCon() { return this.$route.query },
    },
    watch:{
        queryCon() { this.getLists(); },
      currentPage() { this.$router.push({name:this.$route.name,query:{...this.queryCon,page:this.currentPage}}) }
    },
    data() {
      return {
        titleArr:[
          {name:'企业名称',width:'w-80'},
          {name:'状态',width:'w-20'},
          {name:'操作',width:'w-20'},
        ],
        currentPage:1,
        PopArr: [],
        activeTab:'1',
        showAccess:false,           //展示账号权限
        defaultProps: {
          children: 'children',
          label: 'title'
        },
        activeName:'1',             //当前tab值
        loading: false
      }
    },
    mounted() {
      this.getLists();
    },
    methods:{
      ...mapActions(['POST_UnionRecordSaleList','POST_UnionRemove']),
      // 切换酒店Tab
      handleClick (e) {
        console.log(e);
        this.activeName = e.name;
        this.getLists();
      },
      getLists() {
        let data = {
          status:this.activeName,
          ...this.queryCon,
          page:this.currentPage
        };
        this.loading = true;
        this.POST_UnionRecordSaleList({data,successFun:()=>{this.loading = false;}});
      },
      //解除关联
      deleteItem(item,i) {
        this.POST_UnionRemove({data: {uid:item.uid},
            successFun: () => {
              this.$message.success('操作成功');
              this.getLists();
            },
        });
      },
      addPosition(){

      },
    },
  }
</script>

<style lang="scss" scoped>
      .activeName  {
        background-color: #fff;
        float: left;
    }
    .activ{
        overflow: hidden;
    }
.scroll{
  min-height: 45px;
  max-height: 50vh
}
.view-box{
  border: 1px solid red
}
.ntm{
  float: left;
}
.fls{
  float: left;
}
.nnsp{
  overflow: hidden;
}
</style>